/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const deleteTrainee = /* GraphQL */ `mutation DeleteTrainee(
  $input: DeleteTraineeInput!
  $condition: ModelTraineeConditionInput
) {
  deleteTrainee(input: $input, condition: $condition) {
    id
    first_name
    last_name
    display_name
    display_company
    visitor_type
    phone
    location_id
    company_id
    region_id
    checked_in
    checkin_id
    timestamp
    onsite_pk
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTraineeMutationVariables,
  APITypes.DeleteTraineeMutation
>;
export const deleteCheckIn = /* GraphQL */ `mutation DeleteCheckIn(
  $input: DeleteCheckInInput!
  $condition: ModelCheckInConditionInput
) {
  deleteCheckIn(input: $input, condition: $condition) {
    id
    trainee_id
    location_id
    timestamp
    type
    trainee_name
    trainee_phone
    trainee_company
    display_company
    visitor_type
    onsite_pk
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCheckInMutationVariables,
  APITypes.DeleteCheckInMutation
>;
export const createTrainee = /* GraphQL */ `mutation CreateTrainee(
  $input: CreateTraineeInput!
  $condition: ModelTraineeConditionInput
) {
  createTrainee(input: $input, condition: $condition) {
    id
    first_name
    last_name
    display_name
    display_company
    visitor_type
    phone
    location_id
    company_id
    region_id
    checked_in
    checkin_id
    timestamp
    onsite_pk
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTraineeMutationVariables,
  APITypes.CreateTraineeMutation
>;
export const updateTrainee = /* GraphQL */ `mutation UpdateTrainee(
  $input: UpdateTraineeInput!
  $condition: ModelTraineeConditionInput
) {
  updateTrainee(input: $input, condition: $condition) {
    id
    first_name
    last_name
    display_name
    display_company
    visitor_type
    phone
    location_id
    company_id
    region_id
    checked_in
    checkin_id
    timestamp
    onsite_pk
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTraineeMutationVariables,
  APITypes.UpdateTraineeMutation
>;
export const createCheckIn = /* GraphQL */ `mutation CreateCheckIn(
  $input: CreateCheckInInput!
  $condition: ModelCheckInConditionInput
) {
  createCheckIn(input: $input, condition: $condition) {
    id
    trainee_id
    location_id
    timestamp
    type
    trainee_name
    trainee_phone
    trainee_company
    display_company
    visitor_type
    onsite_pk
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCheckInMutationVariables,
  APITypes.CreateCheckInMutation
>;
export const updateCheckIn = /* GraphQL */ `mutation UpdateCheckIn(
  $input: UpdateCheckInInput!
  $condition: ModelCheckInConditionInput
) {
  updateCheckIn(input: $input, condition: $condition) {
    id
    trainee_id
    location_id
    timestamp
    type
    trainee_name
    trainee_phone
    trainee_company
    display_company
    visitor_type
    onsite_pk
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCheckInMutationVariables,
  APITypes.UpdateCheckInMutation
>;
